import ApiBase from '@model/api-base';
import di from 'dependeny-injection'

/**
 * EdilentWorkerChatApi
 *
 * @package     edilent-worker
 * @author      Kenichi Kashiwagi <pod@cro-co.co.jp>
 */
class EdilentWorkerChatApi extends ApiBase {
    constructor(room_id = '---') {
        super();
        this.room_id = room_id;
    }

    request(action, data = {}) {
        return this.apiPost(`/chat/room/api/v1/${this.room_id}/${action}`, data);
    }
}
export default EdilentWorkerChatApi;